import { type FC, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import AuthContext from '@/context/auth/auth-context';
import useGetMe from '@/hooks/use-get-me';
import getCookieToken from '@/lib/helpers/get-cookie-token';
import showToast from '@/lib/helpers/show-toast';

interface AuthContextProviderProps {
  children: ReactNode;
}

const AuthContextProvider: FC<AuthContextProviderProps> = ({ children }) => {
  const { t } = useTranslation();
  const { data: user, isLoading, isError } = useGetMe();

  const statusToken = getCookieToken('status');

  if (statusToken === 'failed') {
    showToast({
      variant: 'error',
      title: t('common:errors.auth.failed'),
    });
  }

  const value = {
    user,
    isError,
    userRoles: user?.roles || [],
    activeRole: user?.activeRole || '',
    selectablePermissionRoles: user?.selectablePermissionRoles || [],
    selectedPermissionRole: user?.selectedPermissionRole ?? null,
    pendingRoleSelection: user?.pendingRoleSelection ?? false,
    isAuthenticated: !!user && !isError,
    isLoading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;
